import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { footerButtonSx, footerSecondaryButtonSx } from "./formLayout";

interface SubmissionCompleteProps {
  requestId: string;
  onReset: () => void;
  onClose?: () => void;
}

/** 依頼の受付完了画面（リアシストの受付完了画面 CompletedScreen と同じ作り）。 */
export const SubmissionComplete: React.FC<SubmissionCompleteProps> = ({
  requestId,
  onReset,
  onClose,
}) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      py: { xs: 3, sm: 5 },
    }}
  >
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
        mb: 4,
        p: { xs: 3, sm: 4 },
        backgroundColor: "#ffffff",
        borderRadius: { xs: "16px", sm: "20px" },
        border: "1px solid #e5e7eb",
        width: "100%",
        maxWidth: { xs: "100%", sm: "500px" },
        boxShadow:
          "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
      }}
    >
      <Box
        sx={{
          width: { xs: 60, sm: 70 },
          height: { xs: 60, sm: 70 },
          borderRadius: "50%",
          backgroundColor: "#3b82f6",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CheckCircleOutlineIcon
          sx={{ color: "#ffffff", fontSize: { xs: 30, sm: 35 } }}
        />
      </Box>
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          fontSize: { xs: "1.25rem", sm: "1.4rem" },
          color: "#1f2937",
        }}
      >
        依頼を受け付けました
      </Typography>
      <Typography sx={{ color: "#6b7280", fontSize: "0.95rem" }}>
        担当者が内容を確認し、ご入力のメールアドレスへご連絡します。
      </Typography>
      <Typography variant="body2" sx={{ color: "#94a3b8" }}>
        依頼ID: {requestId}
      </Typography>
    </Box>
    <Stack
      direction={{ xs: "column-reverse", sm: "row" }}
      spacing={1.5}
      sx={{ width: { xs: "100%", sm: "auto" } }}
    >
      {onClose ? (
        <Button
          variant="outlined"
          onClick={onClose}
          sx={footerSecondaryButtonSx}
        >
          閉じる
        </Button>
      ) : null}
      <Button variant="contained" onClick={onReset} sx={footerButtonSx}>
        新しい依頼を作成
      </Button>
    </Stack>
  </Box>
);
